import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Routing } from '@core/constants/routing.const';
import { AuthService } from '@services/auth/auth.service';
import { CurrentUserService } from '@services/common/currentuser.service';
import { PermissionService } from '@services/common/permission.service';

export const authGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const currentUserService = inject(CurrentUserService);
  const permissionService = inject(PermissionService);
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    const currentNavigationUrl = router
      .getCurrentNavigation()
      .finalUrl.toString();
    const isAccessible =
      permissionService.checkAppModuleAccess(currentNavigationUrl);
    if (!isAccessible) router.navigate([Routing.Forbidden]);
    return isAccessible;
  } else {
    router.navigate([Routing.Auth]);
    currentUserService.IsUserLoggedIn.next(false);
  }

  // if (!isAuthenticated || !isAccessible) {
  //   router.navigate([Routing.Auth]);
  //   if (!isAuthenticated) currentUserService.IsUserLoggedIn.next(false);
  // }

  return isAuthenticated;
};
